<template>
  <div>
    <v-row v-if="alerts.length" no-gutters>
      <span class="textLight--text font-weight-medium text-h5 text-start">
        {{ $t("alerts") }}
      </span>
    </v-row>

    <v-row>
      <v-col cols="12" v-for="(data, index) in alerts" :key="index">
        <alert
          :icon="data.icon"
          :color="data.color"
          :text="data.text"
          :text2="data.text2"
          :iconColor="data.iconColor"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Alert from "./Alert.vue";

export default {
  props: {
    courses: Array,
  },
  components: {
    Alert,
  },
  computed: {
    alerts() {
      return this.courses.reduce((result, item) => {
        if (item && item.status !== "COMPLETED") {
          const dueDate = this.$moment(parseInt(item.endDate));
          const formattedDueDate = dueDate.format("DD MMM yyyy");
          const daysDifference = this.$moment
            .duration(dueDate.diff(this.$moment()))
            .asDays();

          if (daysDifference < 0) {
            result.push({
              icon: "mdi-alert-octagon-outline",
              color: "#ff525233",
              iconColor: "error",
              text: `You missed a deadline on ${formattedDueDate}`,
              text2: this.getLocalisedValue(item.training.title),
            });
          } else if (daysDifference <= 5) {
            result.push({
              icon: "mdi-alert-outline",
              color: "#fb8c0033",
              iconColor: "warning",
              text: `Course about to due on ${formattedDueDate}`,
              text2: this.getLocalisedValue(item.training.title),
            });
          }
        }

        return result;
      }, []);
    },
  },
};
</script>
